import { conf } from './configService';

const getOrigin = () =>
  conf.isStage
    ? `http://fng-globalsites-stage-html-current-${conf.siteCountryCode}.s3-website.eu-central-1.amazonaws.com`
    : `https://${conf.canonicalDomain}`;

export const shareService = {
  getBrowserUrl: () =>
    `${getOrigin()}${window.location.pathname}${window.location.search}`,

  getShareUrl: ({ type, url, encodedTitle, via, mobile }) => {
    const pageUrl = url || shareService.getBrowserUrl();
    let shareUrl = getOrigin();
    switch (type) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/share?url=${pageUrl}&via=${via}&text=${encodedTitle}`;
        break;
      case 'instagram':
        shareUrl = `https://instagram.com/?share=${pageUrl}`;
        break;
      case 'flipboard':
        shareUrl = `https://share.flipboard.com/bookmarklet/popout?v=2&title=${encodedTitle}&url=${pageUrl}`;
        break;
      case 'whatsapp':
        // Special case for whatsapp if it's on mobile.
        shareUrl = mobile
          ? `whatsapp://send?text=${pageUrl}`
          : `https://web.whatsapp.com/send?text=${pageUrl}`;
        break;
      case 'email':
        shareUrl = `mailto:?subject=NatGeo&body=${pageUrl} - ${encodedTitle}`;
        break;
      default:
        // Default to a twitter URL.
        shareUrl = `https://twitter.com/share?url=${pageUrl}&via=${via}&text=${encodedTitle}`;
        break;
    }

    return shareUrl;
  }
};
